import React, { createContext, useContext, useEffect, useState } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const LIBRARIES = [];

const GoogleMapsContext = createContext({ isLoaded: false, loadError: null, authFailed: false });

export function GoogleMapsProvider({ children }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-maps-shared',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
    libraries: LIBRARIES,
  });

  // The script loads fine even when the key is rejected (ProjectDeniedMapError,
  // RefererNotAllowedMapError, billing disabled, …). Google signals that failure
  // through the global window.gm_authFailure callback — NOT through loadError —
  // so without this the map just renders a silent grey box.
  const [authFailed, setAuthFailed] = useState(false);
  useEffect(() => {
    window.gm_authFailure = () => setAuthFailed(true);
    return () => { delete window.gm_authFailure; };
  }, []);

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError, authFailed }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}

export const useGoogleMaps = () => useContext(GoogleMapsContext);
